export const applicationCodes = {

    ACCUEI: 'ACCUEI',
    ACTCOT: 'ACTCOT',
    ADRMOD: 'ADRMOD',
    AFFIMP: 'AFFIMP',
    ALLOC: 'ALLOC',
    ANCCLO: 'ANCCLO',
    ANCCNT: 'ANCCNT',
    AYDMOD: 'AYDMOD',
    BIGBNF: 'BIGBNF',
    BLQDRT: 'BLQDRT',
    BNFBDR: 'BNFBDR',
    BNFDRT: 'BNFDRT',
    BNFHSA: 'BNFHSA',
    BNFNLI: 'BNFNLI',
    CATEG: 'CATEG',
    CORRES: 'CORRES',
    CPLFAM: 'CPLFAM',
    CSMOD: 'CSMOD',
    CTRAT: 'CTRAT',
    CYCLE: 'CYCLE',
    DOKI: 'DOKI',
    DOKIAC: 'DOKIAC',
    ENCIMP: 'ENCIMP',
    ETACPT: 'ETACPT',
    FACCDE: 'FACCDE',
    FACMVT: 'FACMVT',
    FAFECR: 'FAFECR',
    FFGPRM: 'FFGPRM',
    FFORGL: 'FFORGL',
    FPASCN: 'FPASCN',
    FVUSUB: 'FVUSUB',
    GROUP: 'GROUP',
    HISCHP: 'HISCHP',
    IMPBL: 'IMPBL',
    IMPCOB: 'IMPCOB',
    IMPCOF: 'IMPCOF',
    IMPFAC: 'IMPFAC',
    IMPFAF: 'IMPFAF',
    IMPKDO: 'IMPKDO',
    IMPLOC: 'IMPLOC',
    IMPPAC: 'IMPPAC',
    IMPOT: 'IMPOT',
    IMPPIC: 'IMPPIC',
    IMPPIT: 'IMPPIT',
    IMPPVN: 'IMPPVN',
    IMPTKC: 'IMPTKC',
    IMPRBS: 'IMPRBS',
    IMRCV: 'IMRCV',
    LETAUT: 'LETAUT',
    LIVKDO: 'LIVKDO',
    LOGDEF: 'LOGDEF',
    MAILBL: 'MAILBL',
    MAILCB: 'MAILCB',
    MAIL_FORMULAIRE: 'MAIFRM',
    MAIL_COPIE_CE: 'MAICOP',
    MAILCF: 'MAILCF',
    MAILCV: 'MAILCV',
    MAILFA: 'MAILFA',
    MAILLO: 'MAILLO',
    MAILTC: 'MAILTC',
    MAIKDO: 'MAIKDO',
    MAIPAC: 'MAIPAC',
    MAIRBS: 'MAIRBS',
    MAJPDO: 'MAJPDO',
    MAJPHO: 'MAJPHO',
    MAJPWD: 'MAJPWD',
    MDEFE: 'MDEFE',
    CONTROLE_NUMCHEQUE: 'CNUMCH',
    COPYFA: 'COPYFA',
    COPYCO: 'COPYCO',
    COPYBL: 'COPYBL',
    COPYRV: 'COPYRV',

// Champs concernant la médiathèque

    MDKAAA: 'MDKAAA',
    MDKCDU: 'MDKCDU',
    MDKCIB: 'MDKCIB',
    MDKCOL: 'MDKCOL',
    MDKCOT: 'MDKCOT',
    MDKCRI: 'MDKCRI',
    MDKDED: 'MDKDED',
    MDKDEW: 'MDKDEW',
    MDKDHA: 'MDKDHA',
    MDKDSO: 'MDKDSO',
    MDKDUR: 'MDKDUR',
    MDKEDI: 'MDKEDI',
    MDKETA: 'MDKETA',
    MDKFOR: 'MDKFOR',
    MDKGEN: 'MDKGEN',
    MDKI10: 'MDKI10',
    MDKILI: 'MDKILI',
    MDKIMG: 'MDKIMG',
    MDKLHA: 'MDKLHA',
    MDKLIV: 'MDKLIV',
    MDKNAT: 'MDKNAT',
    MDKNK7: 'MDKNK7',
    MDKNOT: 'MDKNOT',
    MDKNOU: 'MDKNOU',
    MDKNUM: 'MDKNUM',
    MDKPHA: 'MDKPHA',
    MDKREA: 'MDKREA',
    MDKREF: 'MDKREF',
    MDKSCO: 'MDKSCO',
    MDKSST: 'MDKSST',
    MDKSYN: 'MDKSYN',
    MDKTHM: 'MDKTHM',
    MDKTYP: 'MDKTYP',
    MDKPERDU: 'MDKPDU',
    MDKBLOQUE: 'MDKBLK',
    MDKAUCUN: 'MDKAUCUN',
    MDKALL: 'MDKALL',
    MDKZIK: 'MDKZIK',
    MDKVID: 'MDKVID',
    MDKLOG: 'MDKLOG',
    MDKAUT: 'MDKAUT',
    ENSTOCK: 'ENSTOCK',
    EMPRUNTE: 'EMPRUNTE',
    ENTRANSFERT: 'ENTRANSFERT',
    PERDU: 'PERDU',
    BLOQUE: 'BLOQUE',

    MDPDEF: 'MDPDEF',
    MDPFIX: 'MDPFIX',
    METIER: 'METIER',
    Mutuel: 'Mutuel',
    NBPART: 'NBPART',
    NBPIEC: 'NBPIEC',
    NUMPIECE_AUTO: 'NUMPIE',
    PAIESL: 'PAIESL',
    PERDOS: 'PERDOS',
    PERIOD: 'PERIOD',
    PERIOD_PRETSETDONS: 'PERIPD',
    PIMKDO: 'PIMKDO',
    PIMPAC: 'PIMPAC',
    PIMRBS: 'PIMRBS',
    PRESTA: 'PRESTA',
    PRFKAL: 'PRFKAL',
    QFPERS: 'QFPERS',
    REVIMP: 'REVIMP',
    RGLACC: 'RGLACC',
    RGLATT: 'RGLATT',
    RGLQTA: 'RGLQTA',
    RGLSUB: 'RGLSUB',
    RIBMOD: 'RIBMOD',
    SEPIMP: 'SEPIMP',
    SEX: 'SEX',
    SITFAM: 'SITFAM',
    STKVAL: 'STKVAL',
    SURF: 'SURF',
    THEME: 'THEME',
    TIMPDN: 'TIMPDN',
    TITRE: 'TITRE',
    TYPBN: 'TYPBN',
    VUEDEF: 'VUEDEF',
    TFCRFF: 'TFCRFF',
    TFCEFB: 'TFCEFB',
    TFCPRE: 'TFCPRE',
    NPLDIS: 'NPLDIS',
    PDIFLI: 'PDIFLI',
    MAJECR: 'MAJECR',
    COTIS: 'COTIS',
    CTRLNM: 'CTRLNM',
    FACRRP: 'FACRRP',
    LIVRRP: 'LIVRRP',
    REGRRP: 'REGRRP',
    ENGAGEMENT_BUDGETAIRE: 'ENGBUD',
    EDITION_IBAN_BLOQUEE: 'EDIRIB',
    CAISSE_ARRETE: 'CARRET',
    ASSURANCE: 'ASSUR',
    SUPPR_CDE_HISTO: 'SUPHIS',
    MODIF_DOSS_HISTO: 'MODHIS',
    REPREM: 'REPREM',
    UNICITE_MANDAT: 'UNIMAN',
    CRITERE_SOCIAUX_VOIR: 'CRITHI',
    PARSUB: 'PARSUB',
    TRPERC: 'TRPERC',
    PXEMAR: 'PXEMAR',

// // -------------------- MODERATION DE COMMENTAIRE -----------------------
    MODERATION_COMMENTAIRE: 'MODCOM',
// // ----------------------------------------------------------------------

// // -------------------- SPECIFIQUE POLE EMPLOI FICHE PORTAIL ------------
    ABAAD: 'ABAAD',
    RIMPAD: 'RIMPAD',
    ABAOD: 'ABAOD',

// Le RIB/IBAN est nécessaire pour la saisie d'un dossier de prestation en ligne
    RIB_PRESTA: 'RIBPRS',
    MAIL_MEDIA_DISPO: 'EMLMDK',

    AUTHENTIF_FORTE: 'AUTHFO',
    AUTHENTIF_FORTE_BENEFICIAIRE: 'AUTBNF',
    AUTHENTIF_FORTE_UTILISATEUR: 'AUTUSR',

// Disponibilité des articles génériques sur le portail
    ARTICLE_GENE_PORTAIL: 'GENPOR',

// Paramètre d'appli par activité pour l'impression des formulaires
    IMPRESSION_FORMULAIRE: 'FRMACT',

// Paramètre d'appli par le contrôle de la présence d'Iban
    CONTROLE_IBAN: 'CPIBAN',

// Paramètre d'appli permettant d'activer ou non la gestion par cotisations
    GESCOT: 'GESCOT',


    // Paramètre d'appli permettant la personnalisation du libellé de l'encart des bons d'attribution de la médiathèque
    MDKBL: 'MDKBL',


// Paramètre activité de type Location pour le contrôle de la disponibilité d'une location

    CONTROLE_LOCATION_DISPO: 'LOCDIS',


// Paramètre d'appli permettant de faire la modification des participants sur des réservations facturées (locations)

    MODIF_PARTICIPANTS_RESA_FACTURE: 'PARFAC',
    MODIF_PARTICIPANTS_RESA_EL_FACTURE: 'PELFAC',


// Paramètre d'application pour le nombre de lignes d'écritures à afficher dans les tableaux d'écritures

    NB_LIGNES_ECRITURES: 'ECRNLI',


// Paramètre d'application sur l'affichage du numéro de pièce comptable sur le report de fature bénéficiaire

    NUMERO_PIECE_FACTURE_BENEF: 'NPFACB',


// Paramètre d'application permettant la génération automatique du matricule bénéficiaire

    GENERATION_AUTO_MATRICULE: 'GENAUM',

    PREFIXE_SPECIFIQUE_EXPORT: 'PRFCOL',

    AFFICHER_AVOIRS_ACOMPTES_FOURN: 'AVACCF',

    COMMENTAIRE_FICHE_BENEF: 'BECOM',

    ALERTE_BENEF_PANIER_VIDE: 'PANVID',


// Paramètre d'application permettant la gestion des droits du Portail

    GERER_DROITS_PORTAIL: 'GDRPOR',


// Paramètre d'application permettant de bloquer l'accès à l'utilisateur super admin

    BLOCAGE_SUPERADMIN: 'BLQUSA',


// Paramètre d'application permettant de définir si le CE souhaite historiser les modifications faites sur ses bénéficiaires

    HISTORISATION_MODIF_BENEF: 'HISBNF',


// -------------------- MISE A JOUR DES CRITERES SOCIAUX -----------------------


// Paramètre d'application permettant de proposer la mise à jour des critères sociaux au bénéficiaire

    MAJ_CS: 'MAJCS',


// Champ de critère sociaux, le bénéf ne veut renseigner ses critères sociaux
// Champ Booleen, si True alors il ne veut pas les renseigner

    REFUS_MAJ_CRITERES_SOCIAUX: 'REFUCS',


// Paramètre d'application permettant de proposer la mise à jour des critères sociaux au bénéficiaire
// Champ Booleen, si True alors il est stagiaire, en alternance ou n'a pas d'avis d'imposition et ne renseignera pas ses CS

    BENEF_NON_IMPOT_OR_STAG_ALTERN: 'NOTIMP',
// ----------------------------------------------------------------------------

// -------------------- ENVOI DE MAIL A L'ANNULATION AUTOMATIQUE DE LA COMMANDE PORTAIL --------------------


// Paramètre d'activité indiquant si le CE veut recevoir un mail lors de l'annulation d'une commande par les tâches planifiées

    MAIL_CE_ANNUL_PANIER: 'MCEAP',


// Paramètre d'activité indiquant si le CE veut envoyer un mail au bénéf lors de l'annulation d'une commande par les tâches planifiées

    MAIL_BENEF_ANNUL_PANIER: 'MBNFAP',

// Paramètre d'activité indiquant si Les comptes 401 seront automatiquement préfixés par « 401 » lors d l’export comptable

    PREFIXE_401_EXPORT_COMPTA: 'PFX401',

// Paramètre d'activité indiquant si la colonne « Numéro de pièce » sera renseignée sur l’export comptable avec la référence de l’écriture

    NUMERO_PIECE_EXPOR_COMPTA: 'NMPC',

// Paramètre d'activité indiquant si la colonne « référence de l’écriture » sera renseignée sur l’export comptable

    REFERENCE_ECRITURE: 'RFEC',

// Paramètre indiquant s'il faut cacher le mot de passe initial dans la fiche signalétique :

    CHP_HIDE_INITIAL_MDP: 'HIMDP',

// ----------------------------------------------------------------------------

// -------------------- MESSAGE D'AVERTISSEMENT RGPD A LA CONNEXION  --------------------
        MESSAGE_CONNEX_AVERT_RGPB: 'RGPDCO',

// -------------------- AFFICHAGE DE LA REPARTITION DES SUBVENTIONS SUR FACTURES  --------------------
    AFFICHER_REPART_SUB_FAC: 'SUBFAC',

// -------------------- TYPE DE VUE POUR L'AFFICHAGE DE L'HISTORIQUE DES DOSSIERS--------------------
    CHP_TYPE_VUE_HIST_DOSSIER: 'TYPVUE',

    TYPE_EXPORT_FOURNISSEUR: 'TYPEXP',

// -------------------- AJUSTER LE MONTANT PRIS EN COMOMPTE POUR UNE LIGNE DE DOSSIER PRESTATION-------------------
    AJUSTER_MONTANT_PRIS_EN_COMPTE: 'AJSMPC',

// -------------------- GENERATION DES BALISES FIRST LORS DES EXPORTS SEPA -------------------
    GENERER_BALISES_FIRST: 'FRSEPA',

// -------------------- VALIDATION AUTO DES IBAN SAISIS SUR LE PORTAIL  --------------------
    VALIDATION_IBAN_AUTO: 'V_IBAN',

// -------------------- VALIDATION AUTO DES Externes SAISIS SUR LE PORTAIL  --------------------
    VALIDATION_EXTERNE_AUTO: 'V_EXT',

// -------------------- SELECTION DU JOURNAL PAR DEFAUT DANS L ECRAN DES ECRITURES MANUELLES -------------------
    BUDGET_DEFAUT_ECR_MANUELLES: 'BDGDEF',

// -------------------- RECUEIL DU CONSENTEMENT RGPD SUR LE PORTAIL -------------------
    CONSENTEMENT_RGPD: 'CONSEN',

// -------------------- VERSION VUP -------------------
    VERSION_VUP: 'VERVUP',

// <editor-fold desc="Upgestion" defaultState="collapsed">

    CATEGORIE_UPGESTION: 'CATUPG',
    CHAMP_LIBRE_NUM_UPGESTION: 'NUMUPG',

// </editor-fold>

// <editor-fold desc="Spécifique Pôle emploi NPDC" defaultState="collapsed">

    DATE_DEPART_RETRAIRE: 'DATRTR',
    CONJOINT_TRAVAIL_POLEEMPLOI: 'CONPEM',
    CODE_SALARIE_CONJOINT: 'CONMAT',

// </editor-fold>

};
